<div #origin class="popover-trigger" (click)="onTriggerClick($event)">
  <ng-content select="[popoverTrigger]"></ng-content>
</div>
<ng-template #contentTemplate>
  <div class="popover-content" [class.popover-open]="isOpen" role="dialog" (click)="$event.stopPropagation()" data-no-print>
    <ng-content select="[popoverContent]"></ng-content>
  </div>
</ng-template>
